import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-add-product-popup-customize',
  templateUrl: './add-product-popup-customize.component.html',
  styleUrls: ['./add-product-popup-customize.component.css']
})
export class AddProductPopupCustomizeComponent implements OnInit {
  public success = false;
  constructor(private activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.hasOwnProperty('success')) {
        this.success = true;
      }
    });
  }

  ngOnInit() {

  }

}
